import { CardFillType, CardOrientation } from '@/common/types';
import { Badge, Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import { ImageBlock, ImageBlockProps } from '../blocks/ImageBlock/ImageBlock';
import { ListContent, ListContentProps } from '../blocks/ListContent/ListContent';
import { CTA, CTAProps } from '../CTA/CTA';

import styles from './Card.module.scss';

export interface CardProps {
  image?: ImageBlockProps;
  fillType?: CardFillType;
  badge?: string;
  title: string;
  body?: string;
  listContent?: ListContentProps;
  cta?: CTAProps;
  orientation?: CardOrientation;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  image,
  fillType,
  badge,
  title,
  body,
  listContent,
  cta,
  orientation,
  className = '',
}) => {
  const cardClassName = classNames(
    styles['card_container'],
    styles[`card_orientation-${orientation}`],
    styles[`card_fill-${fillType}`],
    !image && styles['card_no-image'],
    className,
  );

  return (
    <div className={cardClassName}>
      {image && image.src && (
        <ImageBlock
          src={image.src}
          alt={image.alt}
          aspectRatio={image.aspectRatio}
          className={styles.image}
          responsive={{
            compactWidth: 363, // Covers mobile 2-card scenario
            desktopWidth: 700, // Covers largest single card
            sizes: '(max-width: 600px) 50vw, (min-width: 1200px) 25vw, 33vw',
          }}
        />
      )}
      <div className={styles.card_content}>
        <div className={styles.card_content_header}>
          {badge && (
            <Badge
              variant="info"
              bordered={false}
              style={{
                width: 'fit-content',
                textTransform: 'uppercase',
                fontWeight: '700',
                backgroundColor: 'var(--marm-color-brand-secondary-action-bg-base,#ceff58)',
              }}
            >
              {badge}
            </Badge>
          )}

          {title && (
            <Typography as="h3" className={styles.title}>
              
            </Typography>
          )}

          {body && (
            <Typography as="p" className={styles.body}>
              {body}
            </Typography>
          )}

          {listContent && (
            <ListContent
              title={listContent.title}
              items={listContent.items}
              cta={listContent.cta}
              showDivider={listContent.showDivider}
              className={styles.list_content}
            />
          )}
        </div>

        {cta && (
          <CTA label={cta.label} link={cta.link} type={cta.type} dataHeapId={cta.dataHeapId} />
        )}
      </div>
    </div>
  );
};
